import React, { Component } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';

const FIELD_TYPES = [
    { type: 'text', label: 'Text Field', icon: 'fa-font' },
    { type: 'email', label: 'Email Field', icon: 'fa-envelope' },
    { type: 'tel', label: 'Phone Field', icon: 'fa-phone' },
    { type: 'number', label: 'Number Field', icon: 'fa-hashtag' },
    { type: 'select', label: 'Dropdown', icon: 'fa-caret-square-o-down' },
    { type: 'multiselect', label: 'Multi-Select', icon: 'fa-check-square' },
    { type: 'checkbox', label: 'Checkbox', icon: 'fa-check-square' },
    { type: 'radio', label: 'Radio Group', icon: 'fa-dot-circle-o' },
    { type: 'date', label: 'Date Picker', icon: 'fa-calendar' },
    { type: 'textarea', label: 'Text Area', icon: 'fa-align-left' },
    { type: 'file', label: 'File Upload', icon: 'fa-upload' },
    { type: 'signature', label: 'Signature', icon: 'fa-pencil-square' },
    { type: 'address', label: 'Address Block', icon: 'fa-map-marker' },
    { type: 'objectIdRef', label: 'Ref Dropdown', icon: 'fa-database' },
    { type: 'objectIdRefMulti', label: 'Ref Multi-Select', icon: 'fa-th-list' },
    { type: 'dynamicArray', label: 'Dynamic Array', icon: 'fa-list-ol' },
    { type: 'section', label: 'Section Header', icon: 'fa-bars' }
];

export default class FieldPalette extends Component {
    render() {
        return (
            <div style={{ padding: '10px' }}>
                <h6 style={{ marginBottom: '10px', fontWeight: 'bold' }}>Field Types</h6>
                <small className="text-muted">Drag fields onto the canvas</small>
                <Droppable droppableId="palette" isDropDisabled={true}>
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {FIELD_TYPES.map((ft, index) => (
                                <Draggable key={ft.type} draggableId={'palette-' + ft.type} index={index}>
                                    {(provided, snapshot) => (
                                        <React.Fragment>
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    ...provided.draggableProps.style,
                                                    padding: '8px 12px',
                                                    marginBottom: '4px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    cursor: 'grab',
                                                    backgroundColor: snapshot.isDragging ? '#e3f2fd' : '#fff',
                                                    fontSize: '13px'
                                                }}
                                            >
                                                <i className={'fa ' + ft.icon} style={{ marginRight: '8px', width: '16px' }} />
                                                {ft.label}
                                            </div>
                                            {snapshot.isDragging && (
                                                <div
                                                    style={{
                                                        padding: '8px 12px',
                                                        marginBottom: '4px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        fontSize: '13px',
                                                        opacity: 0.5
                                                    }}
                                                >
                                                    <i className={'fa ' + ft.icon} style={{ marginRight: '8px', width: '16px' }} />
                                                    {ft.label}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}

export { FIELD_TYPES };
